"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    invite: 'Inbjudan' || 'invite',
    sendCustomerSubUnitInvite: 'Skicka inbjudan till webbshop' || 'sendCustomerSubUnitInvite',
    sendSupplierCustomerInvite: 'Skicka inbjudan till webbshop' || 'sendSupplierCustomerInvite',
    sendPurchasingInvite: 'Skicka inbjudan till Qvanti Purchaser' || 'sendPurchasingInvite',
    accept: 'Acceptera inbjudan' || 'accept',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    email: 'Epost' || 'email',
    message: 'Meddelande' || 'message',
    customerSubUnitId: 'Kund-Id' || 'customerSubUnitId',
    customerSubUnit: 'Bunden till kund' || 'customerSubUnit',
    supplierCustomer: 'Kundnummer' || 'supplierCustomer',
    shopConfig: 'Webbshop Konfiguration' || 'shopConfig',
    purchasing: 'Till Qvanti Purchaser' || 'purchasing',
    endCustomerOrganization: 'Bunden till kundorganization' || 'endCustomerOrganization',
    role: 'Roll' || 'role',
    roles: {
        customerSubUnitAdmin: 'Admin' || 'customerSubUnitAdmin',
        customerSubUnitPurchaser: 'Inköpare' || 'customerSubUnitPurchaser',
        customerSubUnitPurchaserManager: 'Inköpsansvarig + avtalsansvarig' || 'customerSubUnitPurchaserManager',
        customerSubUnitPurchaserAssociateManager: 'Inköpsansvarig' || 'customerSubUnitPurchaserAssociateManager',
    },
};
